import { createSelector } from 'reselect'

export const selectPortfolioFolderTree = (state) => state.portfolioDocuments.tree
export const selectPortfolioTreeLoading = (state) => state.portfolioDocuments.treeLoading
export const selectPortfolioFolderFiles = (folderId) => (state) =>
  state.portfolioDocuments.filesByFolder[folderId] || { items: [], total: 0, page: 1 }
export const selectPortfolioFolderUserCounts = (state) => state.portfolioDocuments.userCounts
export const selectPortfolioDocumentsUploading = (state) => state.portfolioDocuments.uploading
export const selectPortfolioFilesForFolder = (folderId) => (state) =>
  state.portfolioDocuments.portfolioFilesByFolder[folderId] || []
export const selectPortfolioFilesForBp = (bpId) => (state) =>
  state.portfolioDocuments.portfolioFilesByBp[bpId] || []
export const selectLoadedPortfolioFolders = (state) => state.portfolioDocuments.loadedFolders
export const selectLoadingPortfolioFolders = (state) => state.portfolioDocuments.loadingFolders
export const selectPortfolioLoadingProgress = (state) => state.portfolioDocuments.loadingProgress
export const selectPortfolioCursor = (key) => (state) => state.portfolioDocuments.cursorByKey[key] ?? null
export const selectPortfolioHasMore = (key) => (state) => state.portfolioDocuments.hasMoreByKey[key] ?? false

const getPortfolioFilesByFolderRaw = (state) => state.portfolioDocuments.portfolioFilesByFolder

export const selectAllPortfolioFiles = createSelector(
  [getPortfolioFilesByFolderRaw],
  (byFolder) => {
    const seen = new Set()
    const out = []
    Object.values(byFolder || {}).forEach((list) => {
      (list || []).forEach((file) => {
        if (!file || seen.has(file.id)) return
        seen.add(file.id)
        out.push(file)
      })
    })
    return out
  }
)
